import {
  CurrentResultsWrapper,
  PaginatorWrapper,
  RowsPerPageWrapper,
  PagingText
} from './PaginatorStyles';
import BiDropdown from '../../primitives/dropdowns/BiDropdown.primitive';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../app/hooks';
import { convertArrToString } from '../../../util/table-utils';
import { AppConstants } from '../../../constants/AppConstants';

type Props = {
  onSizeChanged: any;
  size: string;
  currentPage: string;
  pagingData?: any;
  refreshPaginatedData?: any;
  containerClass?: string;
  theme?: any;
  disablePageSize?: boolean;
};
const Paginator = ({
  onSizeChanged,
  size,
  currentPage,
  pagingData,
  refreshPaginatedData,
  containerClass,
  theme,
  disablePageSize = true
}: Props) => {
  const options: Array<string> = ['20', '50', '100'];

  const configurationPages: any =
    useAppSelector(
      (state: any) => state.configuration?.solutionConfigurationDefaults?.dataGrid?.pageSizes
    ) || [];

  const sizeChanged = (newSize: string) => {
    onSizeChanged(currentPage, newSize);
  };
  const { t } = useTranslation();

  return (
    <StyledPaginatorWrapper data-testid="paginator">
      {!disablePageSize && pagingData?.size ? (
        <RowsPerPageWrapper> Rows per page</RowsPerPageWrapper>
      ) : (
        ''
      )}
      {!disablePageSize && pagingData?.size ? (
        <BiDropdown
          options={configurationPages.length ? convertArrToString(configurationPages) : options}
          onSelectedOptionChange={sizeChanged}
          value={size}
          containerClassName={containerClass}
          menuPositionTop={true}
        />
      ) : (
        ''
      )}

      <CurrentResultsWrapper>
        {pagingData?.size
          ? `${t('T_SHOWING')} ${parseInt(size) * (parseInt(currentPage) - 1) + 1} -
        ${parseInt(size) * (parseInt(currentPage) - 1) + pagingData?.size}`
          : ''}
      </CurrentResultsWrapper>
      <RowsPerPageWrapper>
        {pagingData?.previous && (
          <PagingText
            onClick={() => {
              refreshPaginatedData(parseInt(currentPage) - 1);
            }}
            data-testid={t('T_PREVIOUS')}
            theme={theme}
          >
            {t('T_PREVIOUS')}
          </PagingText>
        )}
        {pagingData?.previous && pagingData?.next && pagingData?.size === parseInt(size) && '-'}
        {pagingData?.next && pagingData?.size === parseInt(size) && (
          <PagingText
            onClick={() => {
              refreshPaginatedData(parseInt(currentPage) + 1);
            }}
            data-testid={t('T_NEXT')}
            theme={theme}
          >
            {t('T_NEXT')}
          </PagingText>
        )}
      </RowsPerPageWrapper>
    </StyledPaginatorWrapper>
  );
};

const StyledPaginatorWrapper = styled(PaginatorWrapper)`
  .mt-4 {
    margin-top: 0 !important;
  }
`;
export default Paginator;
